var _rect, _line, _line2, _line3, _line4, _line5, _line6, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisplayActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 4,
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 23.5,
    x2: 28.5,
    y2: 23.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 27.5,
    x2: 28.5,
    y2: 27.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 19.5,
    x2: 28.5,
    y2: 19.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 7.5,
    x2: 12.5,
    y2: 7.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 11.5,
    x2: 12.5,
    y2: 11.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 6.5,
    y1: 15.5,
    x2: 12.5,
    y2: 15.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 7.5,
    width: 11,
    height: 8,
    rx: 0.5,
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayActive);
export default __webpack_public_path__ + "static/media/display-active.48bb71ed367433e9a73fb6ee006d834e.svg";
export { ForwardRef as ReactComponent };